import React from "react";
import { Redirect } from "react-router-dom";

export default function LoginPage() {
  return <Redirect to="/" />;
}
